exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3FIK {\n    position: relative;\n}\n\n._2PHU {\n    position: absolute;\n    font-size: 1.8rem;\n    right: -2px;\n    width: 24px;\n    height: 18px;\n    bottom: 2px;\n    border: 2px solid #fff;\n    background-color: #fff;\n    overflow: hidden;\n    /*\n        Safari transform overflow hidden bug\n    */\n    transform: translate3d(0, 0, 0);\n    -webkit-mask-image: -webkit-radial-gradient(white, black);\n}\n\n._2WJs {\n    left: 0;\n    z-index: 1;\n}\n\n._1NFQ {\n    right: 0;\n    z-index: 1;\n}\n", ""]);

// exports
exports.locals = {
	"flagContainer": "_3FIK",
	"flag": "_2PHU",
	"leftFlag": "_2WJs",
	"rightFlag": "_1NFQ"
};